// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionExtras_root__3NCYK","info":"SectionExtras_info__3ypF-","extraList":"SectionExtras_extraList__1ITjh","extraItem":"SectionExtras_extraItem__3hyWe"};